import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p454626448092758016',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
